import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Owners from './pages/Owners';
import OwnerForm from './pages/OwnerForm';
import Properties from './pages/Properties';
import PropertyForm from './pages/PropertyForm';
import PropertyDetails from './pages/PropertyDetails';
import Users from './pages/Users';
import MapView from './pages/MapView';
import PublicRegistration from './pages/PublicRegistration';

// Componente para rotas protegidas
const PrivateRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, loading, isAdmin } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  if (adminOnly && !isAdmin()) {
    return <Navigate to="/" />;
  }
  
  return children;
};

// Componente para rota de login
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner"></div>
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/" />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Página pública de cadastro - sem autenticação */}
      <Route path="/cadastro" element={<PublicRegistration />} />
      
      <Route path="/login" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      
      <Route path="/" element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }>
        <Route index element={<Dashboard />} />
        
        <Route path="proprietarios" element={<Owners />} />
        <Route path="proprietarios/novo" element={<OwnerForm />} />
        <Route path="proprietarios/:id/editar" element={<OwnerForm />} />
        
        <Route path="imoveis" element={<Properties />} />
        <Route path="imoveis/novo" element={<PropertyForm />} />
        <Route path="imoveis/:id" element={<PropertyDetails />} />
        <Route path="imoveis/:id/editar" element={<PropertyForm />} />
        
        <Route path="mapa" element={<MapView />} />
        
        <Route path="usuarios" element={
          <PrivateRoute adminOnly>
            <Users />
          </PrivateRoute>
        } />
      </Route>
      
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
        <ToastContainer 
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Router>
    </AuthProvider>
  );
}

export default App;
